import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React from "react";
import { Link, Navigate } from "react-router-dom";
import { HandleAuthTokenRefreshTimer, safeJson } from "src/app/helpers/Index";
import { LoginDetails, SSOLoginDetails } from "src/app/interfaces/Index";
import { AppSettingsService, AuthService, UserService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./VisitorLogin.css";

declare var FB: any;
declare var gapi: any;

type Props = {};
type State = {
	isLoading: boolean;
	isLoadingFacebook: boolean;
	isLoadingGoogle: boolean;
	loggedIn: boolean;
	loginDetails: LoginDetails;
};
export class VisitorLogin extends React.Component<Props, State> {
	toast: any;

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false,
			isLoadingFacebook: false,
			isLoadingGoogle: false,
			loggedIn: false,
			loginDetails: new LoginDetails()
		};
	}

	componentDidMount() {
		FB.init({
			appId: environment.externalAPIs.facebook.appId,
			cookie: true,
			oauth: true,
			status: true,
			xfbml: true
		});
		gapi.load("auth2", () => {
			gapi.auth2.init({
				client_id: environment.externalAPIs.google.clientId
			}).attachClickHandler(document.getElementById("google-login-button"), {}, (googleUser: any) => this.loginGoogle(googleUser), (error: any) => console.log(error));
		});
		this.isUserLoggedIn();
	}

	async isUserLoggedIn() {
		const res = await safeJson(UserService.loginCheck("Chefs"));
		if (res === true) {
			this.setState({loggedIn: true});
			await HandleAuthTokenRefreshTimer();
		}
	}

	async login() {
		this.setState({isLoading: true});
		const res = await AuthService.login(this.state.loginDetails, "Chefs");
		if (!res.ok) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		} else {
			const json = (await res.json());
			await AppSettingsService.set("accessToken", json.accessToken);
			await AppSettingsService.set("refreshToken", json.refreshToken);
			this.setState({isLoading: false, loggedIn: true});
			await HandleAuthTokenRefreshTimer();
		}
	}

	async loginFacebook() {
		this.setState({isLoadingFacebook: true});
		FB.login((response: any) => {
			if (response.authResponse) this.loginFacebook2(response);
			else this.setState({isLoadingFacebook: false});
		}, {
			scope: "public_profile,email"
		});
	}

	async loginFacebook2(response: any) {
		const facebookLoginDetails = new SSOLoginDetails(response.authResponse.accessToken);
		const res = await AuthService.loginFacebook(facebookLoginDetails, "Chefs");
		if (!res.ok) {
			console.log("Error");
			this.setState({isLoadingFacebook: false});
		} else {
			const json = (await res.json());
			await AppSettingsService.set("accessToken", json.accessToken);
			await AppSettingsService.set("refreshToken", json.refreshToken);
			this.setState({isLoadingFacebook: false, loggedIn: true});
			await HandleAuthTokenRefreshTimer();
		}
	}

	async loginGoogle(googleUser: any) {
		this.setState({isLoadingGoogle: true});
		const googleLoginDetails = new SSOLoginDetails(googleUser.getAuthResponse().id_token);
		const res = await AuthService.loginGoogle(googleLoginDetails, "Chefs");
		if (!res.ok) {
			console.log("Error");
			this.setState({isLoadingGoogle: false});
		} else {
			const json = (await res.json());
			await AppSettingsService.set("accessToken", json.accessToken);
			await AppSettingsService.set("refreshToken", json.refreshToken);
			this.setState({isLoadingGoogle: false, loggedIn: true});
			await HandleAuthTokenRefreshTimer();
		}
	}

	render() {
		return (
			<>
				<div className="chef-login" style={{background: "linear-gradient(0deg, rgba(43, 172, 101, 0.75), rgba(43, 172, 101, 0.75)), url(/assets/bg2.jpg)", backgroundColor: colours.primary, backgroundSize: "cover"}}>
					<div className="wrapper">
						<div className="panel">
							<Link style={{display: "block", fontFamily: "Gilroy-Bold, sans-serif", marginBottom: 50, textDecoration: "none"}} to=".">
								<img src="/assets/Logo.png" style={{height: 50}}></img>
								<br/>
								CHEF PORTAL
							</Link>
							<Button disabled={this.state.isLoading || this.state.isLoadingGoogle} iconPos="right" label="Facebook" loading={this.state.isLoadingFacebook} onClick={() => this.loginFacebook()} style={{backgroundColor: colours.brands.facebook, borderColor: colours.brands.facebook, marginBottom: 10, textTransform: "uppercase", width: "50%"}}/>
							<Button disabled={this.state.isLoading || this.state.isLoadingFacebook || this.state.isLoadingGoogle} iconPos="right" id="google-login-button" style={{backgroundColor: colours.brands.google, borderColor: colours.brands.google, position: "relative", textTransform: "uppercase", width: "50%"}}>
								<img src="/assets/google_logo.svg" style={{left: 0, position: "absolute"}}></img>
								<span className="p-button-label p-c" id="google-login-button-label">Google</span>
								{this.state.isLoadingGoogle &&
									<span className="p-button-icon p-c p-button-loading-icon p-button-icon-right pi pi-spinner pi-spin"></span>
								}
							</Button>
							<div id="g-signin2"></div>
							<div style={{backgroundColor: colours.quinary, height: 1, marginBottom: 20, marginTop: 20, width: "50%"}}></div>
							<InputText disabled={this.state.isLoading || this.state.isLoadingFacebook || this.state.isLoadingGoogle} id="emailAddress" onChange={(e) => this.setState({loginDetails: {...this.state.loginDetails, emailAddress: e.target.value}})} placeholder="Email" style={{backgroundColor: colours.quinary, marginBottom: 10, padding: "0.5rem", width: "50%"}} value={this.state.loginDetails.emailAddress}/>
							<InputText disabled={this.state.isLoading || this.state.isLoadingFacebook || this.state.isLoadingGoogle} id="password" onChange={(e) => this.setState({loginDetails: {...this.state.loginDetails, password: e.target.value}})} placeholder="Password" style={{backgroundColor: colours.quinary, marginBottom: 10, padding: "0.5rem", width: "50%"}} type="password" value={this.state.loginDetails.password}/>
							<Button disabled={this.state.isLoadingFacebook || this.state.isLoadingGoogle} iconPos="right" label="Login" loading={this.state.isLoading} onClick={() => this.login()} style={{backgroundColor: colours.primary, borderColor: colours.primary, textTransform: "uppercase", width: "50%"}}/>
							<Link style={{color: colours.quaternary, display: "block", marginTop: 10, textDecoration: "none"}} to="/forgot-password">Forgot Password?</Link>
							<p style={{marginTop: 30}}>Don't you have an account, <Link style={{color: colours.primary, textDecoration: "none"}} to="/chef/sign-up">sign up</Link>?</p>
							{this.state.loggedIn && (
								<Navigate replace={true} to={`/${environment.build.visitorRoute}/home`}/>
							)}
						</div>
						<div>
							<svg className="waves" preserveAspectRatio="none" shapeRendering="auto" viewBox="0 24 150 28" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
								<defs>
									<path d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" id="gentle-wave"/>
								</defs>
								<g className="parallax">
									<use fill="rgba(225, 225, 225, 0.7)" x="48" xlinkHref="#gentle-wave" y="0"/>
									<use fill="rgba(225, 225, 225, 0.5)" x="48" xlinkHref="#gentle-wave" y="3"/>
									<use fill="rgba(225, 225, 225, 0.3)" x="48" xlinkHref="#gentle-wave" y="5"/>
									<use fill="#ffffff" x="48" xlinkHref="#gentle-wave" y="7"/>
								</g>
							</svg>
						</div>
					</div>
				</div>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}
}